import { Outlet, useNavigate, useLocation, Link } from "react-router-dom";
import { useAuth, SignedIn, SignedOut } from "@clerk/react-router";
import { Button } from "@/components/ui/button";
import { UserButton } from "@clerk/react-router";
import Footer from "./Footer";
import { Logo } from "./Logo";
import { cn } from "@/lib/utils";

export default function PublicLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const { isSignedIn } = useAuth();

  return (
    <div className="min-h-screen bg-background flex flex-col">
      {/* Top Navigation - Same as protected Layout */}
      <header className="sticky top-0 z-40 w-full bg-gradient-to-r from-[var(--surface-container)] to-[var(--surface-container-high)]">
        <div className="container mx-auto flex h-14 md:h-14 items-center justify-between px-4 md:px-4 gap-2">
          <div className="flex items-center gap-2 shrink-0">
            <Link to={isSignedIn ? "/dashboard" : "/"} className="flex items-center">
              <Logo variant="small" className="h-7 w-auto" />
            </Link>
          </div>
          
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-1 flex-1 justify-center min-w-0">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => navigate("/dashboard")}
              className={cn(
                "px-3 text-sm h-9",
                location.pathname === "/dashboard" && "bg-[var(--primary-container)] text-[var(--primary-container-foreground)]"
              )}
            >
              Dashboard
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => navigate("/income")}
              className={cn(
                "px-3 text-sm h-9",
                location.pathname === "/income" && "bg-[var(--primary-container)] text-[var(--primary-container-foreground)]"
              )}
            >
              Income
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => navigate("/expenses")}
              className={cn(
                "px-3 text-sm h-9",
                location.pathname === "/expenses" && "bg-[var(--primary-container)] text-[var(--primary-container-foreground)]"
              )}
            >
              Expenses
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => navigate("/savings")}
              className={cn(
                "px-3 text-sm h-9",
                location.pathname === "/savings" && "bg-[var(--primary-container)] text-[var(--primary-container-foreground)]"
              )}
            >
              Savings
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => navigate("/settings")}
              className={cn(
                "px-3 text-sm h-9",
                location.pathname === "/settings" && "bg-[var(--primary-container)] text-[var(--primary-container-foreground)]"
              )}
            >
              Settings
            </Button>
          </nav>

          <div className="flex items-center gap-2 shrink-0">
            <SignedIn>
              <UserButton afterSignOutUrl="/" />
            </SignedIn>
            <SignedOut>
              <div className="hidden md:flex items-center gap-2">
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => navigate("/signin")}
                  className="px-3 text-sm h-9"
                >
                  Sign In
                </Button>
                <Button
                  size="sm"
                  onClick={() => navigate("/signup")}
                  className="px-3 text-sm h-9"
                >
                  Sign Up
                </Button>
              </div>
            </SignedOut>
          </div>
        </div>
      </header>

      <main className="flex-1 pb-16 md:pb-0">
        <div className="container mx-auto px-4 md:px-6 py-4 md:py-6 max-w-7xl">
          <Outlet />
        </div>
      </main>
      <Footer />
    </div>
  );
}

